import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  totalFeeBeforeDiscounts: 0,
  totalPrice: 0,
  productPrice: 0,
  deliveryPrice: 0,
  totalPriceAfterDiscount: 0,
  finalCart: [],
  finalPayment: 0,
  euro: 0,
  allAddresses: [],
  selectedAddress: null,
  deliveryMethod: null,
  paymentMethod: "",
  temporaryCart: JSON.parse(localStorage.getItem("temporaryCart")) || [],
  pendingItem: null,
};

const normalizeQuantity = (quantity) => Math.max(1, Number(quantity) || 1);

const calculateProductPrice = (products) =>
  products.reduce((total, product) => {
    return (
      total +
      normalizeQuantity(product.selected_quantity) * (Number(product.sale_price) || 0)
    );
  }, 0);

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    set(state, action) {
      state.products = action.payload.map((product) => ({
        ...product,
        selected_quantity: normalizeQuantity(product.selected_quantity),
      }));
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    setPendingItem(state, action) {
      state.pendingItem = action.payload;
    },

    clearPendingItem(state) {
      state.pendingItem = null;
    },
    add(state, action) {
      if (
        !state.products.find(
          (el) => +el.variation_id === +action.payload.variation_id
        )
      ) {
        state.products.push({
          ...action.payload,
          selected_quantity: normalizeQuantity(action.payload.selected_quantity),
        });
      }
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    addToTemporaryCart(state, action) {
      if (
        !state.temporaryCart.find(
          (el) => +el.variation_id === +action.payload.variation_id
        )
      ) {
        state.temporaryCart.push({
          ...action.payload,
          selected_quantity: normalizeQuantity(action.payload.selected_quantity),
        });
      }
      localStorage.setItem(
        "temporaryCart",
        JSON.stringify(state.temporaryCart)
      );
      state.productPrice = calculateProductPrice(state.temporaryCart);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.temporaryCart);
    },

    removeFromTemporaryCart(state, action) {
      // console.log(action);
      state.temporaryCart = state.temporaryCart.filter(
        (el) => +el.variation_id !== +action.payload.variation_id
      );
      localStorage.setItem(
        "temporaryCart",
        JSON.stringify(state.temporaryCart)
      );
      state.productPrice = calculateProductPrice(state.temporaryCart);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.temporaryCart);
    },

    remove(state, action) {
      state.products = state.products.filter(
        (el) => +el.variation_id !== +action.payload.variation_id
      );
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    increment(state, action) {
      const product = state.products.find(
        (el) => +el.variation_id === +action.payload.variation_id
      );
      if (product) {
        product.selected_quantity += 1;
      }
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    setQuantity(state, action) {
      const product = state.products.find(
        (el) => +el.variation_id === +action.payload.id
      );

      if (product) {
        product.selected_quantity = normalizeQuantity(action.payload.quantity);
      }

      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    decrement(state, action) {
      const product = state.products.find(
        (el) => +el.variation_id === +action.payload.variation_id
      );
      if (product && product.selected_quantity > 1) {
        product.selected_quantity -= 1;
      }
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    calculateTotalPrice(state) {
      state.productPrice = calculateProductPrice(state.products);
      state.totalFeeBeforeDiscounts = calculateProductPrice(state.products);
    },

    setProductPrice(state, action) {
      state.productPrice = Number(action.payload) || 0;
    },

    setDeliveryMethodPrice(state, action) {
      state.deliveryPrice = Number(action.payload) || 0;
    },

    setTotalPriceBeforeDiscout(state, action) {
      state.totalFeeBeforeDiscounts = Number(action.payload) || 0;
    },

    setTotalPriceAfterDiscout(state, action) {
      state.totalPriceAfterDiscount = Number(action.payload) || 0;
    },

    setFinalCart(state, action) {
      state.finalCart = state.products.filter(
        (el) => normalizeQuantity(el.selected_quantity) > 0
      );
      state.finalPayment = state.productPrice;
    },
    setEuro(state, action) {
      state.euro = action.payload;
    },
    setAllAddresses(state, action) {
      state.allAddresses = action.payload;
    },
    setSelectedAddress(state, action) {
      state.selectedAddress = action.payload;
    },
    resetSelectedAddress(state, action) {
      state.selectedAddress = null;
    },
    setPaymentMethod(state, action) {
      state.paymentMethod = action.payload;
    },
    setDeliveryMethod(state, action) {
      state.deliveryMethod = action.payload;
    },
    resetDeliveryMethod(state) {
      state.deliveryMethod = null;
    },
    setTotalPrice(state, action) {
      state.productPrice = Number(action.payload) || 0;
    },
  },
});

export default cartSlice;
